module.exports = __webpack_public_path__ + "img/0Q3B5808_9-HDR_Black_MockedUp.aacc2d6a.jpg";